/* eslint-disable @next/next/no-img-element */
'use client'

import useAuctionManager from '@hooks/useAuctionManager'
import { useCallback, useMemo, useState } from 'react'

export default function FloatingDabbaButton() {
  const [isHovered, setIsHovered] = useState(false)
  const { currentCat } = useAuctionManager()

  const hasDabbaAttribute = useMemo(() => {
    if (!currentCat) return false
    return Object.keys(currentCat?.attribute).find((attribute) =>
      (currentCat?.attribute as any)[attribute]
        ?.toLowerCase()
        .includes('dabba'),
    )
  }, [currentCat])

  const handleClick = useCallback(() => {
    window.open('https://dabba.com/dewicats', '_blank')
  }, [])

  if (!hasDabbaAttribute) return null

  return (
    <button
      className={`fixed bottom-4 right-4 z-50 rounded-full bg-dark-8 border-[#ffd903] border-2 text-white shadow-lg transition-all duration-300 ease-in-out ${
        isHovered ? 'w-auto max-w-[calc(100%-2rem)] px-4' : 'w-28'
      } h-16 flex items-center justify-center overflow-hidden`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
      aria-label="DeWiCats Dabba discounts"
    >
      <span
        className={`whitespace-normal ${isHovered ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300 flex-row flex items-center gap-2`}
      >
        <img
          src="/assets/dabbaLogo.jpg"
          alt="DeWiCats"
          className="w-10 h-10 rounded-full"
        />
        Pspsps... DeWiCats, follow me to your Dabba discounts 🐱
      </span>
      <span
        className={`absolute ${isHovered ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
      >
        pspsps...🐱
      </span>
    </button>
  )
}
